/**
 * /payment/cancel — user backed out of Stripe checkout. No charge was made.
 */
import { Link } from "react-router-dom";
import { XCircle, Heart } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="max-w-lg mx-auto px-6 py-20 text-center" data-testid="payment-cancel-page">
      <div className="wofy-card py-14">
        <XCircle className="w-10 h-10 mx-auto" style={{ color: "var(--wofy-text-soft)" }} />
        <h1 className="font-display text-2xl mt-3">Payment cancelled.</h1>
        <p className="text-sm mt-2" style={{ color: "var(--wofy-text-soft)" }}>
          No charge was made. You can come back any time — the memorial wall is patient.
        </p>
        <Link to="/celebrate" className="wofy-btn-primary mt-6 inline-flex" data-testid="payment-cancel-back-btn">
          <Heart className="w-4 h-4" /> Browse memorials
        </Link>
      </div>
    </div>
  );
}
